// extracted by mini-css-extract-plugin
module.exports = {"avatar":"UserAvatar_avatar__2GHxz","avatarImage":"UserAvatar_avatarImage__1nxMD","avatarText":"UserAvatar_avatarText__23kAQ","active":"UserAvatar_active__23Skp"};